export interface IExchangeRate {
    card_product_id?: string;
    transaction_type?: string;
    fxrate_mode?: string;
    currency_pairs: Array<ICurrencyPairs>;
    transaction_id?: string;
}

export interface ICurrencyPairs {
    from: string,
    to: string,
    exchange_rate_ids?: Array<string>,
    exchange_rate_id?: string,
    exchange_rate?: number
}